import { api } from "./api";

export const getCompanyDetailAPI = () => {
  return api.get("manage/company/detail");
};

export const updateCompanyAPI = (data) => {
  return api.put("manage/company/update", data);
};
